import { gql } from '@apollo/client';

const CALL_CENTER_ACTIVE_TIME_TRACKING_MUTATION = gql`
  mutation callCenterActiveTimeTracking($input: CallCenterActiveTimeTrackingInput) {
    callCenterActiveTimeTracking(input: $input) {
      isSuccess
      message
    }
  }
`;

export default CALL_CENTER_ACTIVE_TIME_TRACKING_MUTATION;
